import React from 'react';

const ReportsMenuActiveIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    {...props}
  >
    <defs>
      <filter
        id="yj8iydfika"
        width="118.8%"
        height="133.3%"
        x="-9.4%"
        y="-10.7%"
        filterUnits="objectBoundingBox"
      >
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius="1.5"
          result="shadowSpreadOuter1"
        />
        <feOffset
          dx="-1"
          dy="6"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        />
        <feComposite
          in="shadowOffsetOuter1"
          in2="SourceAlpha"
          operator="out"
          result="shadowOffsetOuter1"
        />
        <feColorMatrix
          in="shadowOffsetOuter1"
          values="0 0 0 0 0.160784314 0 0 0 0 0.219607843 0 0 0 0 0.250980392 0 0 0 0.15 0"
        />
      </filter>
      <path
        id="gp158z3krb"
        d="M14.4 43.385V45h-1.6v-1.615h1.6zm3.2 0V45H16v-1.615h1.6zm3.2 0V45h-1.6v-1.615h1.6zM4 36.923c1.061-.003 2.08.423 2.828 1.183C7.578 38.863 8 39.89 8 40.962 8 43.192 6.21 45 4 45s-4-1.808-4-4.039c0-2.23 1.79-4.038 4-4.038zm7.2 3.23v1.616H9.6v-1.615h1.6zm3.2 0v1.616h-1.6v-1.615h1.6zm3.2 0v1.616H16v-1.615h1.6zM37.46 3.048c5.275-.525 9.972 3.367 10.492 8.691.008.024.016.048.022.073-.002.038-.006.075-.012.112.02.255.038.51.038.77.001 2.56-1.004 5.015-2.795 6.828-.007.008-.01.017-.017.025-.007.012-.017.012-.025.017-1.652 1.658-3.846 2.65-6.171 2.792.379 2.226.238 4.51-.41 6.673-2.303 7.684-10.342 12.03-17.953 9.703-7.612-2.326-11.915-10.441-9.612-18.126 2.304-7.686 10.342-12.03 17.954-9.704.787-4.232 4.246-7.43 8.49-7.854z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <use fill="#000" filter="url(#yj8iydfika)" xlinkHref="#gp158z3krb" />
          <path
            fill="#293840"
            stroke="#FFF"
            strokeWidth="2"
            d="M15.4 42.385V46h-3.6v-3.615h3.6zm3.2 0V46H15v-3.615h3.6zm3.2 0V46h-3.6v-3.615h3.6zM3.997 35.923c1.33-.004 2.606.529 3.541 1.479.936.944 1.462 2.224 1.462 3.56 0 1.39-.559 2.648-1.461 3.559C6.633 45.435 5.382 46 4 46c-1.382 0-2.633-.565-3.539-1.48C-.44 43.61-1 42.353-1 40.962c0-1.39.559-2.648 1.461-3.559.906-.914 2.157-1.479 3.536-1.479zm8.203 3.23v3.616H8.6v-3.615h3.6zm3.2 0v3.616h-3.6v-3.615h3.6zm3.2 0v3.616H15v-3.615h3.6zm18.762-37.1c2.913-.29 5.668.638 7.765 2.376 2.094 1.735 3.533 4.275 3.82 7.212.037.532.053.789.053 1.05.002 2.825-1.108 5.534-3.087 7.535-1.608 1.615-3.627 2.65-5.793 3.007.207 2.043.011 4.11-.58 6.082-1.231 4.107-3.996 7.321-7.469 9.198-3.476 1.88-7.662 2.419-11.735 1.175-4.07-1.244-7.255-4.034-9.115-7.542-1.858-3.504-2.392-7.724-1.161-11.828 1.23-4.108 3.995-7.322 7.468-9.2 3.185-1.72 6.966-2.318 10.71-1.45.553-1.898 1.607-3.565 3.003-4.856 1.65-1.526 3.777-2.526 6.12-2.76z"
          />
        </g>
        <path
          fill="#EDF4F7"
          d="M4 36.923c-2.21 0-4 1.808-4 4.038C0 43.192 1.79 45 4 45s4-1.808 4-4.038c0-1.072-.422-2.1-1.172-2.856-.749-.76-1.767-1.186-2.828-1.183z"
        />
        <path
          fill="#F7FAFC"
          d="M40.174 13.339l6.226-.572c-.014 1.837-.652 3.613-1.806 5.033l-4.42-4.461z"
        />
        <path
          fill="#C5D4DB"
          d="M46.254 11.158l-7.054.646V4.657c3.512.362 6.376 3.002 7.051 6.5h.003z"
        />
        <path
          fill="#96A7B0"
          d="M37.6 4.657v8.035c0 .015.008.03.009.045.004.076.02.152.045.223.009.026.016.05.027.074.037.084.088.16.151.226l5.624 5.678c-3.415 2.83-8.456 2.33-11.26-1.119-2.802-3.448-2.306-8.537 1.11-11.367 1.223-1.015 2.718-1.64 4.294-1.795z"
        />
        <path
          fill="#EDF4F7"
          d="M24.8 37.73c-7.07.018-12.814-5.754-12.83-12.891-.018-7.138 5.7-12.937 12.769-12.954 1.382-.003 2.756.22 4.068.66 0 .049-.007.097-.007.147.007 4.937 3.683 9.082 8.543 9.63 1.407 6.946-3.03 13.728-9.91 15.149-.866.179-1.749.266-2.633.26z"
        />
        <path
          fill="#96A7B0"
          d="M21.6 31.269L18.4 31.269 18.4 18.346 21.6 18.346z"
        />
        <path
          fill="#C5D4DB"
          d="M26.4 31.269L23.2 31.269 23.2 21.577 26.4 21.577z"
        />
        <path
          fill="#F7FAFC"
          d="M31.2 24.808L31.2 31.269 28 31.269 28 24.808z"
        />
        <g fill="#293840">
          <path
            d="M14.4 40.385V42h-1.6v-1.615h1.6zm3.2 0V42H16v-1.615h1.6zm3.2 0V42h-1.6v-1.615h1.6zM4 33.923c1.061-.003 2.08.423 2.828 1.183C7.578 35.863 8 36.89 8 37.962 8 40.192 6.21 42 4 42s-4-1.808-4-4.039c0-2.23 1.79-4.038 4-4.038zm1.697 2.325c-.938-.946-2.457-.946-3.394 0-.937.947-.937 2.481 0 3.427.95.915 2.444.915 3.394 0l.122-.132c.814-.953.773-2.391-.122-3.295zm5.503.906v1.615H9.6v-1.615h1.6zm3.2 0v1.615h-1.6v-1.615h1.6zm3.2 0v1.615H16v-1.615h1.6zM37.46.047c5.275-.525 9.972 3.367 10.492 8.691.008.024.016.048.022.073-.002.038-.006.075-.012.112.02.255.038.51.038.77.001 2.56-1.004 5.015-2.795 6.828-.007.008-.01.017-.017.025-.007.012-.017.012-.025.017-1.652 1.658-3.846 2.65-6.171 2.792.379 2.226.238 4.51-.41 6.673-2.303 7.684-10.342 12.03-17.953 9.703-7.612-2.326-11.915-10.441-9.612-18.126C13.321 9.919 21.36 5.575 28.971 7.9c.787-4.232 4.246-7.43 8.49-7.854zM24.74 8.885c-7.07.017-12.787 5.816-12.77 12.954.017 7.137 5.762 12.909 12.831 12.892.884.006 1.767-.081 2.633-.26 6.88-1.42 11.317-8.203 9.91-15.149-4.86-.548-8.536-4.693-8.543-9.63l.007-.148c-1.312-.44-2.686-.662-4.068-.66zM23.2 13.73v3.23H28v3.231h4.8v9.693h-16V13.73h6.4zm-1.6 1.615h-3.2V28.27h3.2V15.346zm4.8 3.231h-3.2v9.692h3.2v-9.692zm4.8 3.23H28v6.462h3.2v-6.461zm6.4-20.15c-1.576.156-3.071.78-4.295 1.795-3.415 2.83-3.911 7.92-1.108 11.367 2.803 3.448 7.844 3.95 11.26 1.12l-5.625-5.679c-.063-.066-.114-.142-.151-.226-.011-.024-.018-.048-.027-.074-.026-.071-.041-.147-.045-.223-.001-.015-.009-.03-.009-.045zm8.8 8.11l-6.226.572 4.42 4.461c1.154-1.42 1.792-3.196 1.806-5.033zm-7.2-8.11v7.147l7.054-.646c-.678-3.499-3.542-6.14-7.054-6.501z"
            transform="translate(0 3)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default ReportsMenuActiveIcon;
